import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzsi = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel7'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel5'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
            <article class="container">
    <h1 class="title">Monty Hall problem</h1>
    
    <div class="text">
        <p>Suppose you’re on a game show, and you’re given the choice of three doors: Behind one door is a car; behind
            the others, goats. You pick a door, say No. 1, and the host, who knows what’s behind the doors, opens
            another door, say No. 3, which has a goat. He then says to you, “Do you want to pick door No. 2?” Is it to
            your advantage to switch your choice?<br/>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/MontyHall.png" alt="220px-Monty_open_door.svg"/>
        </p>
        <p>Source: <a target="_blank" rel="noopener noreferrer nofollow"
                href="http://en.wikipedia.org/wiki/Monty_Hall_problem">http://en.wikipedia.org/wiki/Monty_Hall_problem</a>&nbsp;
        </p>
        <p><strong>Solution:</strong>&nbsp;<br/>If you switch, you get the car with probability 2/3. So switching is
            always a good choice. Refer <a target="_blank" rel="noopener noreferrer nofollow"
                href="http://ocw.mit.edu/courses/electrical-engineering-and-computer-science/6-042j-mathematics-for-computer-science-fall-2010/video-lectures/lecture-18-probability-introduction/">this
            </a>MIT video lecture for great explanation. Refer <a target="_blank" rel="noopener noreferrer nofollow"
                href="http://www.simulateanything.com/simulation?id=monty_hall&amp;v=20">online editable Monty hall
                simulation </a>to play with how things change with multiple doors, prizes etc.&nbsp;</p>
        <p>Please write comments if you find anything incorrect, or you want to share more information about the topic
            discussed above<br/>If “the host, who knows what’s behind the doors” opens a door which has a goat, then the
            probability the car was behind that door was 0 before the door was opened (actually, as soon as the car was
            placed behind a door). Since the host knows which door has the car behind it, then the probability that the
            car is behind that door is 1. Hence, the probability of winning by switching is either 0 (if the host knows
            that door does not have the car behind it) or 1 (if the host knows that door does have the car behind it),
            not 2/3.</p>
    </div>
</article>
        </div>
    )
}

export default Puzsi
